import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogUERBaseCostEstimateBasisResourcesGql } from '../../../catalogUerBaseCostQueries';

interface IUseCatalogUERBaseCostEstimateBasisResources {
    catalogUniqueId?: string;
    uerBaseCostId?: number;
    withEffect?: boolean;
}

const requestId = 'catalogUERBaseCostEstimateBasisResources';

export const useCatalogUERBaseCostEstimateBasisResources = (props: IUseCatalogUERBaseCostEstimateBasisResources) => {
    const { catalogUniqueId, uerBaseCostId, withEffect } = props;

    const variables = useMemo(
        () => (catalogUniqueId && uerBaseCostId ? { catalogUniqueId, uerBaseCostId } : undefined),
        [catalogUniqueId, uerBaseCostId],
    );

    const [catalogUERBaseCostEstimateBasisResourcesReset] = useResetStoreData({ requestId });

    const [catalogUERBaseCostEstimateBasisResourcesData, catalogUERBaseCostEstimateBasisResourcesStatus] = useRequest({
        requestId,
        query: catalogUERBaseCostEstimateBasisResourcesGql,
        variables,
        withEffect: !!variables && withEffect,
    });

    useEffect(() => {
        catalogUERBaseCostEstimateBasisResourcesReset(undefined);
    }, [catalogUERBaseCostEstimateBasisResourcesReset]);

    const items = useMemo(
        () => catalogUERBaseCostEstimateBasisResourcesData?.catalogUERBaseCostEstimateBasisResources?.items || [],
        [catalogUERBaseCostEstimateBasisResourcesData?.catalogUERBaseCostEstimateBasisResources?.items],
    );

    return {
        status: catalogUERBaseCostEstimateBasisResourcesStatus,
        items,
    };
};
